import {
  Grid,
  Typography,
  Button,
  Avatar,
  DialogContent,
} from "@material-ui/core";
import React from "react";
import Text from "../utilities/Text";
import { AccountsData, UserData } from "../Contexts";
import { useLanguage } from "../hooks";
import { getUserData } from "../utilities/api";
import axios from "axios";
import { useHistory } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";

export default function MultiDialog(props) {
  const [_, setUserCtx] = React.useContext(UserData);
  const [userAccounts] = React.useContext(AccountsData);
  const [loading, setLoading] = React.useState(false);
  const [disabled, setDisabled] = React.useState(false);

  const language = useLanguage();
  const history = useHistory();
  const currentId = localStorage?.getItem("userAccount");
  async function handleClick(id) {
    axios.defaults.headers.common["x-keshet-account"] = id;
    localStorage.setItem("userAccount", id);
    console.log("pushed ", id);
    setLoading(id);
    setDisabled(true);
    const res = await getUserData();

    if (res.status === 200) {
      setLoading(false);
      setDisabled(false);
      setUserCtx({ user: res.data });
      props.close(false);
      history.push("/");
    } else {
      history.push("/login");
    }
  }
  const firstLetters = (name) => {
    if (name?.split(" ").length > 1) {
      return name?.split(" ")[0].charAt(0) + name?.split(" ")[1].charAt(0);
    } else {
      return "OO";
    }
  };
  return (
    <DialogContent
      style={{
        backgroundColor: "#F8F8F8",
        textAlign: "center",
      }}
    >
      <div style={{ textAlign: "start" }}>
        <Typography variant="h2">
          {" "}
          <Text objectName="title" page="multi" />
          {language === "he"
            ? userAccounts?.accounts[0]?.Content_name_HEB
            : userAccounts?.accounts[0]?.Content_name_ENG}
        </Typography>
        <Typography variant="body2" style={{ marginBottom: 24 }}>
          <Text objectName="choose" page="multi" />
        </Typography>
      </div>
      <div style={{ textAlign: "center" }}>
        {userAccounts &&
          userAccounts?.accounts?.map((item, index) => {
            return (
              <React.Fragment>
                <Grid
                  container
                  spacing={1}
                  justifyContent="center"
                  alignItems="center"
                  alignContent="center"
                >
                  <Grid item xs={2}>
                    <Avatar
                      alt="{avatarLetters}"
                      style={{
                        backgroundColor: "#FFFFFF",
                        color:
                          currentId === item.Account_id ? "red" : "#004E5E",
                        fontWeight: 700,
                        //   marginInlineStart: "8px",
                      }}
                    >
                      {firstLetters(item.Account_name_HEB)}
                    </Avatar>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography
                      variant="body2"
                      color={
                        currentId === item.Account_id ? "secondary" : "primary"
                      }
                      //style={{ margin: "0px 8px" }}
                    >
                      {item.Account_name_HEB}
                    </Typography>
                  </Grid>

                  <Grid item xs={4}>
                    <Button
                      variant="outlined"
                      color="primary"
                      disabled={disabled || currentId === item.Account_id}
                      style={{
                        height: 44,
                        width: 99,
                        border: "none",
                        backgroundColor: "#FFFFFF",
                      }}
                      onClick={() => {
                        handleClick(item.Account_id);
                      }}
                    >
                      {loading === item.Account_id ? (
                        <CircularProgress />
                      ) : currentId === item.Account_id ? (
                        <Text objectName="current" page="multi" />
                      ) : (
                        <Text objectName="select" page="multi" />
                      )}
                    </Button>
                  </Grid>
                </Grid>
                <div
                  style={{
                    borderBottom: "1px solid #F1F1F1",
                    margin: "20px 0px",
                  }}
                ></div>
              </React.Fragment>
            );
          })}
      </div>
    </DialogContent>
  );
}
